module.exports = __webpack_public_path__ + "img/Youtube.c54aa238.png";